const STORAGE_KEY = "pbx_signup_token";

/**
 * Capture ?signup_token=... from the URL into sessionStorage (one-time signup link, SIP-5528),
 * then scrub it from the address bar so it can't leak via Referer, history, or shared URLs.
 */
export function captureSignupToken(): void {
    const url = new URL(window.location.href);
    const token = url.searchParams.get("signup_token");

    if (token) {
        sessionStorage.setItem(STORAGE_KEY, token);

        url.searchParams.delete("signup_token");
        window.history.replaceState({}, "", url);
    }
}

/** Returns the captured signup token, or undefined. */
export function getSignupToken(): string | undefined {
    return sessionStorage.getItem(STORAGE_KEY) ?? undefined;
}

/** Request headers carrying the signup token, or {} when none captured. */
export function getSignupTokenHeaders(): Record<string, string> {
    const token = getSignupToken();

    return token ? { "X-Signup-Token": token } : {};
}
